export enum NewsVideosPageIds {
    news = 'news',
    videos = 'videos'
}

export enum NewsVideosPageRoutePaths {
    news = '/news',
    videos = '/weather-videos'
}
